import {
    SEARCH_RECEIPT_APPROVAL,
    SEARCH_RECEIPT_APPROVAL_SUCCESS,
    SEARCH_RECEIPT_APPROVAL_FAILED,
    FILTER_SEARCH_RECEIPT_APPROVAL,
    CLEAR_FILTER_SEARCH_RECEIPT_APPROVAL,
    VIEW_RECEIPT_APPROVAL,
    VIEW_RECEIPT_APPROVAL_SUCCESS,
    VIEW_RECEIPT_APPROVAL_FAILED,
    POST_RECEIPT_APPROVAL,
    POST_RECEIPT_APPROVAL_SUCCESS,
    POST_RECEIPT_APPROVAL_FAILED,
    CALCULATE_RECEIPT_POINT,
    CALCULATE_RECEIPT_POINT_SUCCESS,
    CALCULATE_RECEIPT_POINT_FAILED,
    RESET_RECEIPT_APPROVAL_STATUS
} from "constants/ActionTypes";

const INIT_STATE = {
    loader: false,
    alertMessage: "",
    showMessage: false,
    listReceipt: [],
    recordInfo: { totalRecords: 0, page: 0, nrecords: 10 },
    filterAndSort: {
        pagination: null,
        filters: null,
        sorter: null,
        search: "",
        mobileNumber: "",
        startDate: null,
        endDate: null
    },
    data: null,
    updateSuccess: false,
    updateFailed: false,
    submitting: false,
    calculating: false,
    calculatedAccPoint: null,
    calculateError: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FILTER_SEARCH_RECEIPT_APPROVAL:
            return { ...state, filterAndSort: action.payload };

        case CLEAR_FILTER_SEARCH_RECEIPT_APPROVAL:
            return {
                ...state,
                filterAndSort: {
                    pagination: null,
                    filters: null,
                    sorter: null,
                    search: "",
                    mobileNumber: "",
                    startDate: null,
                    endDate: null
                }
            };

        case SEARCH_RECEIPT_APPROVAL:
            return {
                ...state,
                loader: true,
                showMessage: false,
                alertMessage: "",
                listReceipt: []
            };

        case VIEW_RECEIPT_APPROVAL:
            return { ...state, loader: true, data: null, calculatedAccPoint: null, calculateError: null };

        case POST_RECEIPT_APPROVAL:
            return {
                ...state,
                submitting: true,
                showMessage: false,
                alertMessage: "",
                updateSuccess: false,
                updateFailed: false
            };

        case SEARCH_RECEIPT_APPROVAL_SUCCESS: {
            const paging = action.payload.paging;
            return {
                ...state,
                loader: false,
                listReceipt: action.payload.body || [],
                recordInfo: paging
                    ? {
                          totalRecords: paging.totalElements,
                          page: paging.page,
                          nrecords: paging.pageSize
                      }
                    : state.recordInfo
            };
        }

        case SEARCH_RECEIPT_APPROVAL_FAILED:
            return {
                ...state,
                loader: false,
                alertMessage: action.payload,
                showMessage: true,
                listReceipt: []
            };

        case VIEW_RECEIPT_APPROVAL_SUCCESS:
            return { ...state, loader: false, data: action.payload };

        case VIEW_RECEIPT_APPROVAL_FAILED:
            return {
                ...state,
                loader: false,
                alertMessage: action.payload,
                showMessage: true
            };

        case POST_RECEIPT_APPROVAL_SUCCESS:
            return {
                ...state,
                submitting: false,
                updateSuccess: true,
                updateFailed: false
            };

        case POST_RECEIPT_APPROVAL_FAILED:
            return {
                ...state,
                submitting: false,
                updateSuccess: false,
                updateFailed: true,
                alertMessage:
                    (action.payload && action.payload.alertMessage) || "Update failed",
                showMessage: true
            };

        case CALCULATE_RECEIPT_POINT:
            return {
                ...state,
                calculating: true,
                showMessage: false,
                alertMessage: ""
            };

        case CALCULATE_RECEIPT_POINT_SUCCESS:
            return {
                ...state,
                calculating: false,
                calculatedAccPoint: action.payload ? action.payload.accPoint : null
            };

        case CALCULATE_RECEIPT_POINT_FAILED:
            return {
                ...state,
                calculating: false,
                calculateError: action.payload
            };

        case RESET_RECEIPT_APPROVAL_STATUS:
            return {
                ...state,
                calculateError: null,
                calculatedAccPoint: null,
                updateSuccess: false,
                updateFailed: false,
                alertMessage: "",
                showMessage: false
            };

        default:
            return state;
    }
};
